import NewPatientValidation from './NewPatientValidation';

export default NewPatientValidation;
